<section class="tender-countdown">
  <div class="tender-countdown__header">
    <div class="tender-countdown__title-wrap">
      <i class="iconsax tender-countdown__icon" icon-name="clock"></i>
      <p class="tender-countdown__title">
        {{ 'tenders.proposalPhaseClosesIn' | translate }}
      </p>
    </div>

    @if (estimatedLabel()) {
      <span class="tender-countdown__estimate">EST. {{ estimatedLabel() }}</span>
    }
  </div>

  @if (isExpired()) {
    <p class="tender-countdown__expired">
      {{ 'tenders.proposalPhaseEnded' | translate }}
    </p>
  } @else {
    <div class="tender-countdown__grid">
      <div class="tender-countdown__unit">
        <span class="tender-countdown__number">{{ countdown().days }}</span>
        <span class="tender-countdown__label">{{ 'global.day' | translate }}</span>
      </div>
      <div class="tender-countdown__unit">
        <span class="tender-countdown__number">{{ countdown().hours }}</span>
        <span class="tender-countdown__label">{{ 'tenders.hours' | translate }}</span>
      </div>
      <div class="tender-countdown__unit">
        <span class="tender-countdown__number">{{ countdown().minutes }}</span>
        <span class="tender-countdown__label">{{ 'tenders.mins' | translate }}</span>
      </div>
      <div class="tender-countdown__unit">
        <span class="tender-countdown__number">{{ countdown().seconds }}</span>
        <span class="tender-countdown__label">{{ 'tenders.secs' | translate }}</span>
      </div>
    </div>
  }
</section>
